import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useScrollYPosition } from "react-use-scroll-position";

import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import "../styles/navbar.css";
import "../styles/login.css";
import { auth } from "../Page/Firebase";
import { useNavigate } from "react-router-dom";

const Login = ({ links }) => {
    const re = useNavigate()
    const userEmail = localStorage.getItem("auth")
    const [menuOpen, setMenuOpen] = useState(false);
    const scrollY = useScrollYPosition();
    const [email, setEmail] = useState()
    const [password, setpassword] = useState()
    const stickeyTrigger = window.innerHeight / 2.75;
    const Login = (e) => {
        e.preventDefault()
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential;
                console.log(user, "lokesh")
                localStorage.setItem('auth', user.user.email)
                re('/')
            })
            .catch((error) => {
                window.alert(error.message);
                console.log(error.code);
                console.log(error.message);
            });
    }
    const handleClick = async (e) => {
        e.preventDefault()
        console.log(email, password)
        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential;
                window.alert("Success")
                console.log(user.email);
                localStorage.setItem('auth', user.user.email)
                re('/')
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage)
            });
    }
    const logout = () => {
        signOut(auth).then((r) => {
            console.log("logout", userEmail)
            localStorage.clear()
            window.location.reload();
            console.log("Done")
        }).catch((error) => {
            console.log(error)
        });
    }
    return (
        <>
            <Container>
                <div className={`nav${scrollY > stickeyTrigger ? " nav-stickey" : ""}${menuOpen ? " nav-open" : ""}`}>
                    <div className="nav-content">
                        <div className="nav-logo">Online Meeting Experiment</div>
                        <div className="nav-menu__icon" onClick={() => setMenuOpen(!menuOpen)}>
                            <div />
                            <div />
                        </div>
                    </div>
                </div>
            </Container>
            <div class="wrapper">
                <div class="card-switch">
                    <label class="switch">
                        <input class="toggle" type="checkbox" />
                        <span class="slider"></span>
                        <span class="card-side"></span>
                        <div class="flip-card__inner">
                            <div class="flip-card__front">
                                <div class="title">Login</div>
                                <form action="" class="flip-card__form">
                                    <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} name="email" class="flip-card__input" />
                                    <input type="password" placeholder="Password" onChange={(e) => setpassword(e.target.value)} name="password" class="flip-card__input" />
                                    <button class="flip-card__btn" onClick={(e) => Login(e)}>Login</button>
                                </form>
                            </div>
                            <div class="flip-card__back">
                                <div class="title">Sign Up</div>
                                <form action="" class="flip-card__form">
                                    <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} name="email" class="flip-card__input" />
                                    <input type="password" placeholder="Password" onChange={(e) => setpassword(e.target.value)} name="password" class="flip-card__input" />
                                    <button class="flip-card__btn" onClick={(e) => handleClick(e)}>Sign Up</button>
                                </form>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </>
    )
}
Login.defaultProps = {
    links: [
        { title: "Home", href: "#home" },
        // { title: "Features", href: "#features" },
        // { title: "Contact", href: "#contact" },
        // { title: "Login", href: "login" }
    ]
};
export default Login
